import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MemberStateService} from '../../services/member-state.service';
import {UserContextService} from '../../services/user-context.service';
import {Observable} from 'rxjs';
import {EmployerHoliday} from '../../model/employer-holiday';
import {ViewState, toViewState} from '../../model/view-state';
import {concatMap, take} from 'rxjs/operators';
import {AdmissibilityService} from '../../services/admissibility.service';
import { IntroductionComponent } from '../shared/introduction/introduction.component';
import { AlertComponent } from '../shared/alert/alert.component';
import { LoaderComponent } from '../shared/loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-vacation',
    standalone: true,
    templateUrl: './vacation.component.html',
    styleUrls: ['./vacation.component.css'],
    imports: [IntroductionComponent, AlertComponent, LoaderComponent, TranslatePipe, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VacationComponent implements OnInit {
  private admissibilityService = inject(AdmissibilityService);
  private memberStateService = inject(MemberStateService);
  private userContext = inject(UserContextService);

  state$: Observable<ViewState<EmployerHoliday>>;
  currentYear: number;

  ngOnInit() {
    this.currentYear = (new Date()).getFullYear();
    const isInternalUser = this.userContext.isInternalUser();

    // Use /me endpoint for external users, /{inss} for internal users
    const holidays$ = isInternalUser
      ? this.memberStateService.getMember().pipe(
          take(1),
          concatMap(member => this.admissibilityService.getEmployerHolidays(member.personalInformation.inss))
        )
      : this.admissibilityService.getMyEmployerHolidays();

    this.state$ = holidays$.pipe(toViewState());
  }

  getUsedDays(holiday: EmployerHoliday): number {
    if (!holiday) return 0;
    return holiday.employerHolidayCredit - holiday.employerHolidayBalance;
  }

  getUsedPercentage(holiday: EmployerHoliday): number {
    if (!holiday || holiday.employerHolidayCredit === 0) return 0;
    return (this.getUsedDays(holiday) / holiday.employerHolidayCredit) * 100;
  }
}
